module.exports = "/_next/static/resources/array-275272bf0c3c763928e90a4a0faaaf64.jpg";